import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { DayjsTransformReturn } from 'frontend-utils/transforms/dayjs';
import type {
  ActionStatus,
  ActivityActionTranslationKeys,
  ActivityCategory,
} from 'lumen/utils/constants/activity-action-constants';

export interface ActivityAction {
  key: ActivityActionTranslationKeys;
  values: Record<string, string>;
}

export default class ActivityLog extends Model {
  [Type] = 'activity-log' as const;

  @attr declare action: ActivityAction;
  @attr('string') declare actionStatus: ActionStatus;
  @attr('string') declare category: ActivityCategory;
  @attr declare changes: Record<string, [string | null, string | null]> | null;
  @attr('string') declare ipAddress: string;
  @attr('string') declare location: string;
  @attr('dayjs') declare timestamp: DayjsTransformReturn;
  @attr('string') declare userEmail: string;
  @attr('number') declare userId: number;
  @attr('string') declare userName: string;
}
